import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
	formatSimulationByIdResponse,
} from "../utils/simulacao-utils";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";

export function useSimulationById({ enabled = true } = {}) {
	const { id } = useParams();

	const [simulation, setSimulation] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchSimulationById(simulationId = id) {
		if (!simulationId) {
			return null;
		}

		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const requestOptions = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				}
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API + `pacto-rebates-simulador/v1/simulacoes/${encodeURIComponent(simulationId)}`,
				requestOptions
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar a simulação."
				);
			}

			const data = await response.json();
            
			const simulationData = Array.isArray(data.resultado)
				? data.resultado[0]
				: data.resultado || data;

			const formattedSimulation = formatSimulationByIdResponse(simulationData);

			setSimulation(formattedSimulation);

			return {
				ok: true,
				simulation: formattedSimulation
			};
		} catch (requestError) {
			setSimulation(null);
			setError(requestError.message);

			return {
				ok: false,
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
        if (!enabled || !id) {
            return;
        }

        fetchSimulationById(id);
    }, [enabled, id]);

	return {
		simulation,
		loading,
		error,
		fetchSimulationById
	};
}